import { Link } from "react-router-dom";

const expertiseLinks = [
  { slug: "civil-litigation", label: "Civil Litigation" },
  { slug: "criminal-litigation", label: "Criminal Litigation" },
  { slug: "commercial-disputes", label: "Commercial Disputes" },
  { slug: "real-estate-rera", label: "Real Estate & RERA" },
  { slug: "corporate-advisory", label: "Corporate Advisory" },
  { slug: "contract-drafting", label: "Contract Drafting" },
  { slug: "due-diligence", label: "Due Diligence" },
  { slug: "legal-notices-pleadings", label: "Legal Notices" },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-deep-ink text-ivory"
    >
      <div className="container-px max-w-[1400px] mx-auto py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-10">
          {/* Brand */}
          <div className="md:col-span-4">
            <img
              src="/brand/lex-polaris-logo-transparent.png"
              alt="Lex Polaris, Advocates & Solicitors"
              className="h-16 md:h-20 w-auto object-contain mb-3"
              data-testid="footer-logo"
              loading="lazy"
            />
            <div className="text-[10px] tracking-[0.32em] uppercase text-ivory/55">
              Advocates &amp; Solicitors
            </div>
            <div className="editorial-rule mt-7 mb-7" />
            <p className="text-ivory/70 text-sm leading-relaxed max-w-[320px]">
              Sharp, Strategic Counsel. A research-driven law practice for litigation, dispute resolution and
              corporate advisory matters in Delhi NCR and Gurugram.
            </p>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-2">
            <div className="overline text-gold mb-5">Navigate</div>
            <ul className="space-y-3 text-sm">
              {[
                { to: "/", label: "Home" },
                { to: "/about", label: "About" },
                { to: "/expertise", label: "Expertise" },
                { to: "/principal-advocate", label: "Principal Advocate" },
                { to: "/insights", label: "Insights" },
                { to: "/contact", label: "Contact" },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-ivory/75 hover:text-gold transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Expertise */}
          <div className="md:col-span-3">
            <div className="overline text-gold mb-5">Expertise</div>
            <ul className="space-y-3 text-sm">
              {expertiseLinks.map((l) => (
                <li key={l.slug}>
                  <Link
                    to={`/expertise/${l.slug}`}
                    data-testid={`footer-expertise-${l.slug}`}
                    className="text-ivory/75 hover:text-gold transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-3">
            <div className="overline text-gold mb-5">Contact</div>
            <ul className="space-y-3 text-sm text-ivory/75">
              <li>
                <a
                  href="tel:+919810899124"
                  data-testid="footer-phone"
                  className="hover:text-gold transition-colors"
                >
                  +91 98108 99124
                </a>
              </li>
              <li>
                <a
                  href="tel:+911244231444"
                  data-testid="footer-landline"
                  className="hover:text-gold transition-colors"
                >
                  0124-4231444
                </a>
              </li>
              <li>
                <a
                  href="mailto:admin@lexpolaris.in"
                  data-testid="footer-email"
                  className="hover:text-gold transition-colors break-all"
                >
                  admin@lexpolaris.in
                </a>
              </li>
              <li className="pt-2 leading-relaxed">
                G Block, 22nd Floor, M3M Broadway,<br />
                SPR Road, Sector 71, Gurugram,<br />
                Haryana 122101
              </li>
              <li className="pt-2 text-ivory/55 text-xs tracking-[0.16em] uppercase">
                Mon &ndash; Sat &nbsp;&middot;&nbsp; 10:00 &ndash; 19:00
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-ivory/15 flex flex-col md:flex-row md:items-center md:justify-between gap-5">
          <div className="flex flex-col md:flex-row md:items-center gap-x-6 gap-y-2 text-xs text-ivory/55 tracking-wide">
            <span data-testid="footer-copyright">
              &copy; {new Date().getFullYear()} Lex Polaris, Advocates &amp; Solicitors. All rights reserved.
            </span>
            <span className="hidden md:inline text-ivory/25">|</span>
            <span data-testid="footer-credit">
              Designed by{" "}
              <a
                href="https://www.branditify.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-credit-link"
                className="text-ivory/80 hover:text-gold border-b border-ivory/30 hover:border-gold transition-colors"
              >
                Branditify
              </a>
            </span>
          </div>
          <div className="flex flex-wrap gap-x-6 gap-y-2 text-[11px] tracking-[0.22em] uppercase">
            <Link
              to="/privacy"
              data-testid="footer-privacy"
              className="text-ivory/65 hover:text-gold transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              data-testid="footer-terms"
              className="text-ivory/65 hover:text-gold transition-colors"
            >
              Terms of Use
            </Link>
            <Link
              to="/disclaimer"
              data-testid="footer-disclaimer"
              className="text-ivory/65 hover:text-gold transition-colors"
            >
              Disclaimer
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
